<template>
  <div class="echarts" id="threerighttwo"></div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted

  // watch // watch([()=>data.要监听的属性,...监听多个属性],(newValue,oldValue)=>{})
} from "vue";
//
import { unitlist } from "@/api/threeSolid/threeSolidHome.js";
import * as echarts from "echarts";
export default defineComponent({
  name: "",
  components: {},
  props: {},
  setup(props) {
    const data = reactive({
      echartsList: []
    });
    const refData = toRefs(data);
    const numberall = async () => {
      const res = await prisonlist();
      data.echartsList = res.data;
    };
    onMounted(() => {
      // echarts项目初始化
      const myChart = echarts.init(document.getElementById("threerighttwo"));
      myChart.setOption({
        grid: {
          top: 40,
          left: 50,
          right: 30,
          bottom: 50
          // containLabel: true
        },
        title: {
          // text: "年龄结构",
        },
        textStyle: {
          // 图列内容样式
          color: "#fff" // 字体颜色
        },
        tooltip: {},
        xAxis: {
          data: ["文峰街道", "汉丰街道", "云枫街道"],
          axisLine: {
            lineStyle: {
              color: "#08598f" // 横坐标线条颜色
            }
          }
        },
        yAxis: {
          height: 50,
          splitLine: {
            // 网格线
            lineStyle: {
              color: "#08598f",
              type: "dashed" // 设置网格线类型 dotted：虚线   solid:实线
            },
            show: true // 隐藏或显示
          }
        },
        series: [
          {
            itemStyle: {
              color: "#8565ff",
              borderColor: "#8565ff"
            },
            barWidth: "40%",
            name: "",
            type: "bar",
            data: [200, 400, 300]
          }
        ]
      });
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    });
  }
});
</script>
<style lang="scss" scoped>
#threerighttwo {
  width: 100%;
  height: 90%;
}
</style>
